export default __webpack_public_path__ + "static/media/logobg.bd2f7dd0.png";